import { Globals } from "../CoreApp/Globals";

export function GetDateFormatStrList() {
  return Globals._stringMgr.GetDateFormatStrList();
}
